import React from 'react';
import classNames from 'classnames';
import { useAppSelector } from 'store/hooks';
import Whitelist from './Whitelist';
import ActiveRaffles from './ActiveRaffles';
import { ActiveRaffle, ProjectWhitelist } from 'api/project/project_detail';

interface IShowMoreProps {
  id: number;
  isChangeStyle?: boolean;
  openShowMore: boolean;
  getProjectWhitelistRaffle: (isUpdate?: boolean) => void;
  projectWhitelist: ProjectWhitelist[];
  projectActiveRaffle: ActiveRaffle[];
  requested:boolean;
}

const ShowMore: React.FC<IShowMoreProps> = ({
  id,
  isChangeStyle,
  openShowMore,
  getProjectWhitelistRaffle,
  projectActiveRaffle,
  projectWhitelist,
  requested,
}) => {
  const { curExpandProject } = useAppSelector((state) => state.projectDetail);

  if (!openShowMore || curExpandProject !== id) {
    return null;
  }

  return (
    <div
      className={classNames('h-[220px] w-full text-neutral-100 duration-300 ', {
        ' px-4 2xl:px-5': !isChangeStyle,
        'rounded-b-2xl border-4 border-t-0 border-neutral-700 bg-neutral-900 py-5':
          isChangeStyle,
      })}
    >
      <div
        className={classNames({
          flex: isChangeStyle,
          'flex h-full rounded-b-2xl border border-t-0 border-neutral-700 py-5':
            !isChangeStyle,
        })}
      >
        <Whitelist
          isChangeStyle={isChangeStyle}
          id={id}
          projectWhitelist={projectWhitelist}
          getProjectWhitelistRaffle={getProjectWhitelistRaffle}
          requested={requested}
        />
        <div className="h-[180px] w-px bg-neutral-700"></div>
        <ActiveRaffles
          isChangeStyle={isChangeStyle}
          projectActiveRaffle={projectActiveRaffle}
          requested={requested}
        />
      </div>
    </div>
  );
};

export default ShowMore;
